var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.members
    ? _c(
        "div",
        { staticClass: "list" },
        [
          _c(
            "md-table",
            {
              attrs: {
                "md-sort": "name",
                "md-sort-order": "asc",
                "md-card": ""
              },
              model: {
                value: _vm.members,
                callback: function($$v) {
                  _vm.members = $$v
                },
                expression: "members"
              }
            },
            [
              _c("md-table-toolbar", [
                _c("div", { staticClass: "md-toolbar-section-start" }, [
                  _c("h1", { staticClass: "md-title" }, [_vm._v("Members")])
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "md-member-search",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.searchMemberBtn()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "search-container" },
                      [
                        _c(
                          "md-field",
                          {
                            staticClass: "search-input-field",
                            attrs: { "md-clearable": "" }
                          },
                          [
                            _c("md-input", {
                              attrs: {
                                "aria-label": "Search query",
                                name: "searchMember",
                                placeholder: "Search Member..."
                              },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.searchMemberList.apply(
                                    null,
                                    arguments
                                  )
                                }
                              },
                              model: {
                                value: _vm.searchMember,
                                callback: function($$v) {
                                  _vm.searchMember = $$v
                                },
                                expression: "searchMember"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "md-button",
                          {
                            staticClass:
                              "search-addon-btnstyle-member md-button md-accent md-theme-default",
                            attrs: { type: "submit", title: "Search" }
                          },
                          [_c("i", { staticClass: "fa fa-search" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-button",
                          {
                            staticClass:
                              "reset-btn md-button md-accent md-theme-default",
                            attrs: {
                              type: "button",
                              title: "Clear",
                              disabled: !_vm.searchMember
                            },
                            on: { click: _vm.resetSearchMember }
                          },
                          [_c("i", { staticClass: "fa fa-times" })]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "md-table-row",
                [
                  _c("md-table-head", [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("md-table-head", [_vm._v("Email")]),
                  _vm._v(" "),
                  _c("md-table-head", [_vm._v("Last Request")]),
                  _vm._v(" "),
                  _c("md-table-head", [_vm._v("Last Response")]),
                  _vm._v(" "),
                  _c("md-table-head", [_vm._v("Last Feedback")])
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.members, function(member) {
                return [
                  _c("member", { key: member._id, attrs: { member: member } }, [
                    _vm._v("Member goes here...")
                  ])
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.skip + _vm.limit < _vm.count
            ? _c(
                "md-button",
                {
                  staticClass: "md-fab loadmore-button",
                  attrs: { "aria-label": "Load more members" },
                  on: {
                    click: function($event) {
                      return _vm.loadMore()
                    }
                  }
                },
                [
                  _c("md-tooltip", { attrs: { "md-direction": "left" } }, [
                    _vm._v("Load more")
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-icon",
                    [_c("font-awesome-icon", { attrs: { icon: "recycle" } })],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d3072ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3072ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Members.vue
// module id = null
// module chunks = 